export default __webpack_public_path__ + "static/media/BalancedIcon.15a96ac4.svg";